<ul class="social-items" role="list">
  <li>
    <a
      class="social-link"
      href="https://www.linkedin.com/company/immomio-gmbh"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i class="icon icon--linkedin" aria-hidden="true"></i>
      <!--
        Real text rather than an aria-label, so the link still has an accessible
        name if the icon font fails to load or a user forces their own font.
      -->
      <span class="visually-hidden">LinkedIn</span>
    </a>
  </li>
</ul>
